[
  {
    "code": "KG-B",
    "name": "Batken"
  },
  {
    "code": "KG-GB",
    "name": "Bishkek"
  },
  {
    "code": "KG-C",
    "name": "Chü"
  },
  {
    "code": "KG-J",
    "name": "Jalal-Abad"
  },
  {
    "code": "KG-N",
    "name": "Naryn"
  },
  {
    "code": "KG-O",
    "name": "Osh"
  },
  {
    "code": "KG-T",
    "name": "Talas"
  },
  {
    "code": "KG-Y",
    "name": "Ysyk-Köl"
  }
]